var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_225_26)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 42,
    r: 31,
    transform: "rotate(-180 43 42)",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.25,
    y: 18.75,
    width: 46.5,
    height: 46.5,
    transform: "rotate(90 66.25 18.75)",
    fill: "url(#pattern0_225_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_225_26",
    x: 0.5,
    y: 0.5,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_225_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_225_26",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_225_26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_225_26",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_225_26",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACpklEQVR4nO3aPWsUQRwG8BFfYyHYqlhpEwn3Hw/kbLz2IMnNnLCFNlELW7+CRQpRjLWdQgLWscpHEIt0WqSziPgOFpJCfeT2TkGN8W53dnZm9vnB1DvzZHZnniRKERERERERERERERERERERERERUZMgmz0EKyuw+tNoyANknRnVMMg6M/narf44zmFlmI27B4xCxu9DnmMwd0o1BOZbJ/M1/5mDkfvuHmLk/d9B5w95DasvqsRhcL4DI9u7ZmDlnbsH7fqAX2MHVt9QiYKVKzDyZa8MfAX98yf7EDfbB1UikGX7YeXOJGv3HPTwU6I3MD93XEUOvQvHYGV90nX7D3q0s7ew2DqnIoXLchZGXkyz5pqCzsP+DCtGRQYD3RtfYadab41B5+M7jL4NpfapCMDKLRj5WmStLifxqmDYw7EWcrkZlRC9Vnh9Rn9wNxkjyyWCRqjl5p8lZKqgZdndhLrdAzB6teSEtkMqN3uXkIl38+owm6C+Ywio3MDI1f+VkNrPn6InMwIoN9OUkCBuVOO75suSr92Gz3KTlxAjT0uGvIW+zPqas9uJL1ZfboqUkLo3RnSvIlx96qo49FI5XODi8O7r6yokTq5LVp5goX209Fx6Zw7D6EclPxVv0deXVIjQ1ydg9LNyYetNLLRPxzwHL7DUPQKrH9exmxDQW+WN73KDQM8JL3yUG0Rw84m+3CDWEhJTuUGE7dQLOHzFkyohVYFpXRsfdEV34bd8FA95B1aWVBPAyTUssRJSFbgpFmmVkKDLjU2whARcbpBcCakKnNwkEishVYGLu3FqJSTYcmMSLCHhlRtJu4RUBZP/Ri68v4QkV25MA0tIDeVms7ElpOJ/RryX72Cj38DouyH/8yQRERERERERERERERERERERqSj8AF3wJlJD5m1EAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.5638e8ed686300d779057af7e6c07dfd.svg";
export { ForwardRef as ReactComponent };